/* Q3 2026: events for the reviewed NL/BE bridges. Uses the existing Clarity installation. */
(() => {
  if (window.__anodyneQ3BridgeEvents) return;
  const bridges = [...document.querySelectorAll('aside.q3-product-bridge[data-q3-market]')];
  if (!bridges.length) return;
  window.__anodyneQ3BridgeEvents = true;
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const emit = name => {
    if (!allowed() || document.visibilityState !== 'visible' || typeof window.clarity !== 'function') return false;
    try { window.clarity('event', name); return true; } catch (_) { return false; }
  };
  const states = new Map();
  const schedule = state => {
    clearTimeout(state.timer);
    if (state.seen || !state.visible || !allowed() || document.visibilityState !== 'visible') return;
    state.timer = setTimeout(() => {
      if (state.visible && emit(state.prefix + '_view')) state.seen = true;
    }, 1000);
  };
  for (const bridge of bridges) {
    const match = /^q3-20260917-bridge-(\d+)$/.exec(bridge.id);
    const market = bridge.dataset.q3Market.toLowerCase();
    if (!match || !['nl', 'be'].includes(market) || location.hostname.replace(/^www\./, '') !== `anodyne.${market}`) continue;
    const state = { prefix: `q3_20260917_${market}_${match[1]}`, seen: false, clicked: false, visible: false, timer: null };
    states.set(bridge, state);
    bridge.addEventListener('click', event => {
      const link = event.target.closest?.('a[data-q3-bridge-link]');
      if (!event.isTrusted || !link || !bridge.contains(link) || state.clicked) return;
      // A genuine CTA click also proves exposure, including clicks made before the one-second threshold.
      if (!state.seen && emit(state.prefix + '_view')) state.seen = true;
      if (emit(state.prefix + '_click')) state.clicked = true;
    });
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const state = states.get(entry.target);
        if (!state) continue;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        schedule(state);
      }
    }, { threshold: [0, 0.5] });
    for (const bridge of states.keys()) observer.observe(bridge);
  }
  const refresh = () => { for (const state of states.values()) schedule(state); };
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('load', refresh, { once: true });
})();
